import React from 'react'
import { FiMoreHorizontal, FiBarChart, FiThumbsUp, FiHeart, FiUserPlus, FiArrowRightCircle, FiBookmark, FiXOctagon, FiAlertTriangle } from 'react-icons/fi'
import Navbar from '../../../@shared/navigations/default';

const NotificationsPage = () => {

    return (
        <React.Fragment>
            <title>Notifications</title>
            <Navbar />
            <div className="container6" id="account">
            <div className="notifications_page">
                <ul>
                {
                    notificationList.map((item,i)=>(
                        <NotificationItem item={item} key={i} />
                    ))
                }
                </ul>
                <div className="timing">
                   <p>  Recent Notifications </p>
                </div>
            </div>
            
        </div>
        </React.Fragment>
    )
}


export default NotificationsPage



export const NotificationItem = ({item}) =>{
    const [open,setOpen] = React.useState(false);

    return (
        <li className={item.unread ? 'unread' : ''}>
            <div className="flex-start notify">
                <div className="symbol"> {item.symbol} </div>
                <div>
                    {item.image &&  <img src={item.image ? `/assets/images/faces/${item.image}.png` : `/assets/images/faces/default.svg`} alt="" />}
                    {item.images && !item.image &&  (
                        <div className="persons">
                            {item.images.map((image)=>(
                                <img src={`/assets/images/faces/${image}.png`} key={image} alt="" />
                            ))}
                            <p>+250</p>
                        </div>
                    )}
                </div>
                <div>
                    <p className="title">{item.title}</p>
                    <p className="date">{item.date}</p>
                </div>
            </div>
            <div className="more all-unselectable">
                <div onClick={()=>setOpen(!open)}>
                    <FiMoreHorizontal />
                </div>
                {open&&(
                    <div className="more-dropdown dropdown">
                            <ul>
                                {settingList.map(item=>(
                                    <li key={item.title}>
                                        {item.symbol}
                                        {item.title}
                                    </li>
                                ))}
                            </ul>
                    </div>
                )}
            </div>
      </li>
    )
}

export const notificationList = [
    { symbol:<FiBarChart />,title:' This week 9.755 person visited your profile', date:'11 hours', images:[1,2,3,4,5], unread:true},
    { symbol:<FiThumbsUp />,title:'Ahmad and other 75.773 person viewed your post', date:'Yesterday', images:[10,11,1,8,2,5,12,3,4,13]},
    { symbol:<FiHeart />,title:'Abdulkareem created a page', date:'2 days', image:8},
    { symbol:<FiUserPlus />,title:'You have been friended to +25 new persons ', date:'2 days', images:[4,5,10]},
  ]
  export const settingList = [
    {title:'Go', symbol:<FiArrowRightCircle />, url:'#'},
    {title:'Mark readed', symbol:<FiBookmark />, url:'#'},
    {title:'Leave group', symbol:<FiXOctagon /> , url:'#'},
    {title:'Hide', symbol:<FiAlertTriangle />, url:'#'},
]
